import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetSubtaskTemplates } from '@/shared/hooks/task/useGetSubtaskTemplates';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export const SubtaskTemplateSelect = ({ initialValue, placeholder, taskTemplateId, isDisabled, onChange, }) => {
    const { formatMessage } = useIntl();
    const { data, refetch } = useGetSubtaskTemplates(taskTemplateId);
    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskTemplateId]);
    const subtaskTemplates = useMemo(() => data === null || data === void 0 ? void 0 : data.map(item => ({
        key: item.id,
        label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
    })), [data, formatMessage]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (subtaskTemplates === null || subtaskTemplates === void 0 ? void 0 : subtaskTemplates.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, subtaskTemplates]);
    return (_jsx(AutoComplete, { items: subtaskTemplates, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key), disabled: isDisabled }));
};
export const FilterSubtaskTemplateSelect = ({ item, taskTemplatesItem, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    var _a;
    const taskTemplates = (_a = activeFilters[taskTemplatesItem]) !== null && _a !== void 0 ? _a : [];
    const taskTemplateId = taskTemplates.length === 1 ? taskTemplates[0] : null;
    return {
        enabled: enabled,
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(SubtaskTemplateSelect, { onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), initialValue: activeFilters[item], taskTemplateId: taskTemplateId, placeholder: label, isDisabled: !taskTemplateId })),
    };
};
